import { Box, Button, Card, CardContent, CardMedia, Chip, Stack, Typography } from "@mui/material";
import { IRaffle } from "../../../store/interfaces/IRaffle";

export const RaffleCard: React.FC<{ raffle: IRaffle }> = ({ raffle }) => {
  const launchDateFormatted = raffle.launchDate
    ? new Date(raffle.launchDate).toLocaleDateString()
    : "No definida";

  return (
    <Card
      sx={{
        width: 345,
        borderRadius: 4,
        boxShadow: 6,
        overflow: 'hidden',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        backgroundColor: '#121212',
        color: '#fff',
        '&:hover': {
          transform: 'translateY(-5px)',
          boxShadow: 12,
        },
      }}
    >
      <CardMedia
        component="img"
        height="160"
        image={raffle.awards[0]?.images[0] || '/placeholder-image.jpg'}
        alt={raffle.name}
      />
      <CardContent>
        <Typography gutterBottom variant="h6" component="div" fontWeight="bold">
          {raffle.name}
        </Typography>

        {/* Premium & Type */}
        <Stack direction="row" spacing={1} flexWrap="wrap" mb={1}>
          {raffle.isPremium && (
            <Chip label="Premium" size="small" color="primary" />
          )}
          <Chip label={raffle.type.toUpperCase()} size="small" sx={{ backgroundColor: 'gray', color: 'white' }} />
          <Chip label={raffle.status} size="small" sx={{ backgroundColor: raffle.status === 'ACTIVE' ? 'green' : 'red', color: '#fff' }} />
        </Stack>

        {/* Info */}
        <Box mb={1}>
          <Typography variant="body2">
            <strong>Cuenta:</strong> {raffle.accountId}
          </Typography>
          <Typography variant="body2">
            <strong>Precio Ticket:</strong> ${raffle.ticketPrice.toFixed(2)}
          </Typography>
          <Typography variant="body2">
            <strong>Precio USD:</strong> ${raffle.ticketPriceUSD.toFixed(2)}
          </Typography>
          <Typography variant="body2">
            <strong>Lanzamiento:</strong> {launchDateFormatted}
          </Typography>
        </Box>

        {/* Payment Methods */}
        {raffle.availablePaymentMethods.length > 0 && (
          <Stack direction="row" spacing={1} flexWrap="wrap">
            {raffle.availablePaymentMethods.map((method) => (
              <Chip key={method} label={method} size="small" variant="outlined" />
            ))}
          </Stack>
        )}
      </CardContent>
    </Card>
  );
};
